import React, { Component } from 'react';
import { CommonlyHead } from '../common/headnav';
import * as services from '../projects/services';
import { Carousel, Badge, Tabs, WhiteSpace, Toast, Accordion } from 'antd-mobile';
import { Link } from "react-router-dom";
import { Icon } from 'antd';
import { PacksItems } from '../package/item';
import imgURL from '../../res/images/logo.png';
import * as fun from '../../components/common';
import '../common/config';
import '../hospital/style.less';
let mindex = 0;
export default class HospitalDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mcno: this.props.match.params.hospital,
            cname: '',
            hpiclist: [],
            hospital: [],
            packs: null,
            piclist: [],
            tabslist: [],
            descrption: '',
            imgHeight: 176,
            flag: false,
            dataa: ['1', '2', '3'],
            oid: 0,
            defaultActiveKey: 1,
        }

    }
    componentDidMount() {
        services.GetHospitalDetails(this.state.mcno, '').then(value => {
            if (value.status === 0) {
                let picture = imgURL;
                if (value.result.mcLogo.length > 0) {
                    picture = value.result.mcLogo[0].smallpicpath;
                }
                let mcname = value.result.mcname;
                let mcName = value.result.address + ',联系电话：' + value.result.salertel;
                let url = global.constants.wx_tijian + this.props.match.url;
                fun.wxshare(url, mcname, mcName, picture);
                this.setState({
                    cname: mcname,
                    hpiclist: value.result.picture,
                    dataa: value.result.picture,
                    hospital: value.result,
                    flag: true,
                    descrption: value.result.descrption
                });
                this.contentNode.scrollIntoView({ block: "start" });
                services.GetHospitalItem(this.state.mcno, '正在查询,请稍后').then(data => {

                    if (data.status === 0) {
                        let tabslist = [];
                        if (data.result.packCount > 0) {
                            tabslist.push({ title: <Badge text={data.result.packCount}>体检套餐</Badge>, key: '1' });
                        }
                        if (!!value.result.descrption) {
                            tabslist.push({ title: '机构介绍', key: '2' });
                        }
                        this.setState({
                            packs: data.result.packGenders,
                            tabslist: tabslist
                        });

                    } else {
                        Toast.offline(data.message, 2);
                    }
                })
            } else {
                Toast.offline(value.message, 2);
            }
        });

    }
    onTabClick = (tab, index) => {
        this.setState({
            oid: index
        });

    }
    render() {
        mindex++;
        const { cname, hospital, dataa, tabslist } = this.state;

        const sex_male = <div><span className="iconfont icon-nan" style={{ left: '0px' }} ></span><span style={{ marginLeft: "5px" }}>男性套餐</span></div>;
        const sex_female = <div>  <span className="iconfont  icon-nv" style={{ left: '0px' }} ></span><span style={{ marginLeft: "5px" }}>女性套餐</span></div>;
        const sex_all = <div>  <span className="iconfont    icon-999999" style={{ left: '0px' }} ></span><span style={{ marginLeft: "5px" }}>全部套餐</span></div>;
        return (<div className="hospital" ref={node => this.contentNode = node}>
            <CommonlyHead barname={cname} />
            {
                !!dataa === false && mindex > 1 ? '' :
                    dataa.length > 1 ?
                        <Carousel className="space-carousel"
                            autoplay
                            infinite
                            speed={500}
                            autoplayInterval={4000}  >
                            {dataa.map((val, index) => (
                                <div
                                    key={index}>
                                    <img
                                        src={val.picpath}
                                        alt=""
                                        style={{ width: '100%', verticalAlign: 'top' }}
                                        onLoad={() => {
                                            this.setState({ imgHeight: 'auto' });
                                        }}
                                    />
                                </div>
                            ))}
                        </Carousel>
                        :
                        dataa.map((val, index) => (
                            <div
                                key={index}>
                                <img
                                    src={val.picpath}
                                    alt=""
                                    style={{ width: '100%', verticalAlign: 'top' }}
                                    onLoad={() => {
                                        this.setState({ minHeight: 'auto' });
                                    }}
                                />
                            </div>
                        ))
            }
            <div className={dataa.length > 0 && mindex > 0 ? 'hospitalDbox hospitalDbox2 ' : 'hospitalDbox'}>
                <div className="infobox">
                    <div className="cname">{cname}</div>
                    <ul className="infot">
                        <li className="l1"><Icon type="schedule" theme="outlined" style={{ fontSize: '14px', color: '#32a128' }} />上班时间：<span>{hospital.examtime}</span></li>
                        <li className="l2"><Icon type="phone" theme="outlined" style={{ fontSize: '14px', color: '#32a128' }} />电&nbsp;&nbsp;&nbsp;&nbsp;话：<span>
                            <a href={'tel:' + hospital.salertel}> {hospital.salertel}</a>
                        </span> </li>
                        <li className="l3">
                            {
                                !!hospital.longitude && !!hospital.latitude ?

                                    <Link to={`/maps/${hospital.mcname}/${hospital.longitude}/${hospital.latitude}/${hospital.cityName}/${hospital.address}`} >
                                        <Icon type="environment" theme="outlined" style={{ fontSize: '14px', color: '#32a128' }} />地&nbsp;&nbsp;&nbsp;&nbsp;址：<span>{hospital.address}</span>
                                    </Link>
                                    : ''
                            }
                        </li>
                    </ul>
                    <div >
                        {
                            tabslist.length > 0 ?
                                <Tabs tabs={tabslist}
                                    page={this.state.oid}
                                    onTabClick={(tab, index) => { this.onTabClick(tab, index) }}
                                    onChange={(tab, index) => { this.onTabClick(tab, index) }}
                                    tabBarPosition="top"
                                    useOnPan={true}
                                    swipeable={true}
                                >
                                    {
                                        tabslist.length === 2 ?
                                            <div>
                                                {
                                                    this.state.oid === 0 && !!this.state.packs
                                                        ?
                                                        <div className="tabspa">
                                                            <Accordion accordion defaultActiveKey="0" className="my-accordion"  >
                                                                {this.state.packs.map((datalist,indexnum) => (datalist.gender === 1 && datalist.packs.length > 0 ?
                                                                    <Accordion.Panel key={indexnum} header={sex_male}>{datalist.packs.map((data, index2) => (<PacksItems packData={data} type={'h'} key={index2} />))}</Accordion.Panel>
                                                                    :
                                                                    datalist.gender === 2 && datalist.packs.length > 0 ?
                                                                        <Accordion.Panel header={sex_female} key={indexnum} >{datalist.packs.map((data, index2) => (<PacksItems packData={data} type={'h'} key={index2} />))}</Accordion.Panel>
                                                                        : datalist.gender === 0 && datalist.packs.length > 0 ? <Accordion.Panel header={sex_all} key={indexnum} >
                                                                            {datalist.packs.map((data, index2) => (<PacksItems packData={data} type={'h'} key={index2} />))}
                                                                        </Accordion.Panel>
                                                                            : ''
                                                                ))}
                                                            </Accordion>
                                                        </div>
                                                        : ''
                                                }
                                                {
                                                    this.state.oid === 1
                                                        ?
                                                        <div className="tabsp">
                                                            <div dangerouslySetInnerHTML={{ __html: hospital.descrption }} />
                                                        </div>
                                                        : ''
                                                }
                                            </div>
                                            : <div>
                                                {
                                                    parseInt(tabslist[0].key) === 1 && !!this.state.packs
                                                        ?
                                                        <div className="tabspa">
                                                            <div className="tabspa">
                                                                <Accordion accordion defaultActiveKey="0" className="my-accordion" >
                                                                    {this.state.packs.map((datalist) => (
                                                                        datalist.gender === 1 && datalist.packs.length > 0 ?
                                                                            <Accordion.Panel header={sex_male}  key='accordion1'>

                                                                                {datalist.packs.map((data, index) => (<PacksItems packData={data} type={'h'} key={index} />))}

                                                                            </Accordion.Panel>
                                                                            :
                                                                            datalist.gender === 2 && datalist.packs.length > 0 ?
                                                                                <Accordion.Panel header={sex_female}  key='accordion2' >

                                                                                    {datalist.packs.map((data, index) => (<PacksItems packData={data} type={'h'} key={index} />))}

                                                                                </Accordion.Panel>

                                                                                : datalist.gender === 0 && datalist.packs.length > 0 ?
                                                                                    <Accordion.Panel header={sex_all}  key='accordion3' >

                                                                                        {datalist.packs.map((data, index) => (<PacksItems packData={data} type={'h'} key={index} />))}

                                                                                    </Accordion.Panel>


                                                                                    : ''
                                                                    ))}
                                                                </Accordion>
                                                            </div>
                                                        </div>
                                                        : ''
                                                }
                                                {
                                                    parseInt(tabslist[0].key) === 2
                                                        ?
                                                        <div className="tabsp">
                                                            <div dangerouslySetInnerHTML={{ __html: hospital.descrption }} />
                                                        </div>
                                                        : ''
                                                }
                                            </div>
                                    }


                                </Tabs>
                                : ''}
                    </div>
                    <WhiteSpace />
                </div>
            </div>

        </div >);
    };
}
